export default __webpack_public_path__ + "static/367-4fc9f9c05412b6af2d438ac074b75f62.gif";